module.exports = __webpack_public_path__ + "static/media/icon_web.9751f4c5.svg";